import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=0a622e4f&lang=pug"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Address: require('/home/docker/code/frontend/components/Address.vue').default,ProvidersList: require('/home/docker/code/frontend/components/ProvidersList.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
